import React from 'react';
import styled from 'styled-components';

import { BG } from '../../styles/color';
import LogoSrc from '../../assets/logo/logo_grayscale.svg';

const FooterWrapper = styled.footer`
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 180px;
	background-color: ${ BG.deep02 };
	padding: 40px 100px;
	box-sizing: border-box;
`;

const Wrapper = styled.div`
	width: 1080px;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 70px;
`;

const LogoWrapper = styled.div`
	width: 250px;
`;

const Logo = styled.img`
	object-fit: contain;
`;

const InfoWrapper = styled.div`
	width: 450px;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-start;
	flex-wrap: wrap;
	align-content: flex-start;
	gap: 5px 40px;

	// border: 1px solid black;
	// box-sizing: border-box;
`;

const Info = styled.p`
	margin: 0;
	padding: 0;
	font: normal 340 16px Pretendard Variable;
	color: ${ BG.mid };
`;

const Bold = styled.span`
	font-weight: 550;
`;

export default function Footer() {
  return (
	<FooterWrapper>
		<Wrapper>
			<LogoWrapper>
				<Logo src={ LogoSrc }/>
			</LogoWrapper>
			<InfoWrapper>
				<Info><Bold>대표번호</Bold>&emsp;043-881-0716</Info>
				<Info><Bold>팩스</Bold>&emsp;043-882-0716</Info>
				<Info><Bold>주소</Bold>&emsp;충청북도 음성군 대소면 대금로 511번길 96-5</Info>
				<Info><Bold>사업자등록번호</Bold>&emsp;179-81-02036</Info>
				<Info><Bold>대표</Bold>&emsp;고영미, 최&nbsp;훈</Info>
				<br/><br/>
				<Info style={{fontSize: "14px"}}>Copyright ⓒ 2025 YoungWon Cup&Paper.CO.,LTD&emsp;All rights reserved.</Info>
			</InfoWrapper>
		</Wrapper>
	</FooterWrapper>
  );
}
